module.exports = __webpack_public_path__ + "img/RS.e4159b1c.svg";